import { useState, useEffect } from "react";
import { Col, Row, Space, Form } from "antd";
import ButtonAction from "components/Common/ButtonAction";
import CustomAntdTable from "components/Common/CustomAntdTable";
import {
    CustomFormItemTextArea
} from "components/Common/CustomFormItem";
import { formatterAmount, formatterAmountFiveDigit } from "utils/Helper";
import useParamRepo from "services/repo/useParamRepo";
import useWBSRepo from "services/repo/useWBSRepo";
 const getRawValue = (v) => (typeof v === "object" && v !== null ? v.value : v);

export default function SectionWbsTaskApproval({ taskId, isView = false, form, initialTaskList = [], onChangeTaskList }) {
    const [taskList, setTaskList] = useState([]);
    const { isLoading: isLoadingWfList, getParamByCategory } = useParamRepo(false);
    const { isLoading: isLoadingTimeUnit, getWBSTimeUnit } = useWBSRepo(false);

    // 🔹 NEW: master Tipe Kegiatan (wbs_category)
    const [wbsCategoryOptions, setWbsCategoryOptions] = useState([]);

    const [outputUnitOptions, setOutputUnitOptions] = useState([]);
    const fetchDataUnitOutput = async () => {
        const payload = {
            paramCategory: "wbs_output_unit"
        };

        const res = await getParamByCategory(payload);
        if (res?.detail === 'OK' && res?.status === 200) {
            setOutputUnitOptions(
                res.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId  // atau item.paramId jika value pakai ID
                }))
            );
        }
    };

    const [frequencyOptions, setFrequencyOptions] = useState([]);
    const fetchDataFrequency = async () => {
        const payload = {
            paramCategory: "wbs_frequency_type"
        };

        const res = await getParamByCategory(payload);
        if (res?.detail === 'OK' && res?.status === 200) {
            setFrequencyOptions(
                res.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId // atau item.paramId jika ingin pakai ID
                }))
            );
        }
    };


    const [timeUnitOptions, setTimeUnitOptions] = useState([]);
    const fetchDataTimeUnits = async () => {
        const payload = {
            taskId // ganti sesuai kategori param
        };


        const res = await getWBSTimeUnit(payload);
        if (res?.detail === 'OK' && res?.status === 200) {
            setTimeUnitOptions(
                res.data.map(item => ({
                    label: item.wbsTuParamValue,
                    value: item.wbsTuId
                }))
            );
        }
    };

    const fetchDataWbsCategory = async () => {
        const res = await getParamByCategory({ paramCategory: "wbs_category" });
        if (res?.detail === "OK" && res?.status === 200) {
            setWbsCategoryOptions(
                res.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId
                }))
            );
        }
    };



    useEffect(() => {
       

        if (Array.isArray(initialTaskList) && initialTaskList.length > 0) {
            const normalized = initialTaskList.map((item, index) => {
                return {
                    id: item.id || item.wbsContentId || `${Date.now()}-${index}`,
                    taskDescription: item.taskDescription ?? item.wbsContentTask ?? '',
                    remark: item.remark ?? item.wbsContentRemark ?? '',
                    outputUnit: item.outputUnit,
                    timeToComplete: item.timeToComplete,
                    outputTimeToCompleteUnit: item.outputTimeToCompleteUnit,
                    frequency: item.frequency,
                    outputCount: item.outputCount,
                    fte: item.fte,
                    personnel: item.fte,
                    wbsCatId: getRawValue(item.wbsCatId) ?? null,
                    isNew: false
                };
                
            });

            console.log(JSON.stringify(initialTaskList)); 

            setTaskList(normalized);

            // ✅ Set seluruh field input form dari data task
            const formValues = {};
            normalized.forEach(row => {
                formValues[`taskDescription_${row.id}`] = row.taskDescription;
                formValues[`remark_${row.id}`] = row.remark;
                formValues[`outputUnit_${row.id}`] = row.outputUnit;
                formValues[`timeFinish_${row.id}`] = row.timeToComplete;
                formValues[`outputTimeToCompleteUnit_${row.id}`] = row.outputTimeToCompleteUnit;
                formValues[`frequency_${row.id}`] = row.frequency;
                formValues[`outputCount_${row.id}`] = row.outputCount;
            });

            form.setFieldsValue(formValues);
        }
    }, [initialTaskList]);

    useEffect(() => {
        fetchDataUnitOutput();
        fetchDataFrequency();
        fetchDataTimeUnits();
        fetchDataWbsCategory();
    }, []);



    const onChangeInput = (id, field, value) => {
        const updated = taskList.map((item) =>
            item.id === id ? { ...item, [field]: value } : item
        );
        setTaskList(updated);
        onChangeTaskList?.(updated);
    };


    const columns = [
        {
            title: "Uraian Tugas",
            dataIndex: "taskDescription",
            render: (_, row) => (
                <CustomFormItemTextArea
                    nameFormItem={`taskDescription_${row.id}`}
                    value={row.taskDescription}
                    wrapperCol={10}
                    labelCol={12}
                    styleInput={{
                        width: 450,
                        minHeight: 50,
                        maxHeight: 200,
                        overflow: 'hidden',
                        resize: 'none', // agar auto expand tidak terganggu manual resize
                        fontSize: 13,
                        lineHeight: 1.4,
                        padding: '8px 10px',
                    }}
                    autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
                    rows={3} // masih aman untuk default
                    useInTable
                    disabled={true}
                />

            )


        },
        {
            title: "Satuan Hasil",
            dataIndex: "outputUnit",
            render: (_, row) =>
                outputUnitOptions.find(opt => opt.value === row.outputUnit)?.label || "-",
        },

        {
            title: "Waktu Penyelesaian",
            dataIndex: "timeFinish",
            render: (_, row) => row.timeToComplete,
        },

        {
            title: "Satuan Waktu",
            dataIndex: "outputTimeToCompleteUnit",
            render: (_, row) =>
                timeUnitOptions.find(opt => opt.value === row.outputTimeToCompleteUnit)?.label || "-",
        },

        {
            title: "Tipe Frekuensi",
            dataIndex: "frequency",
            render: (_, row) =>
                frequencyOptions.find(opt => opt.value === row.frequency)?.label || "-",
        },
        {
            title: "Hasil Kerja",
            dataIndex: "outputCount",
            render: (_, row) => row.outputCount,
        },

        {
            title: "FTE",
            dataIndex: "fte",
            render: (_, row) => formatterAmountFiveDigit(row.fte),
        },
        {
            title: "Tipe Kegiatan",
            dataIndex: "wbsCatId",
            render: (_, row) => {
                if (!row.wbsCatId) return "-";

                const val = String(row.wbsCatId);
                const match = wbsCategoryOptions.find(
                    opt => String(opt.value) === val
                );

                return match?.label || "-";

            }
        },
        {
            title: "Remarks",
            dataIndex: "Remarks",
            render: (_, row) => (
                <CustomFormItemTextArea
                    nameFormItem={`remark_${row.id}`}
                    value={row.remark}
                    // styleInput={{ width: 350 }}
                    wrapperCol={10}
                    labelCol={12}
                    styleInput={{
                        width: 450,
                        minHeight: 50,
                        maxHeight: 200,
                        overflow: 'hidden',
                        resize: 'none', // agar auto expand tidak terganggu manual resize
                        fontSize: 13,
                        lineHeight: 1.4,
                        padding: '8px 10px',
                    }}
                    autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
                    rows={3} // masih aman untuk default
                    onChange={(e) => onChangeInput(row.id, "remark", e.target.value)}
                    useInTable
                />
               
            ),
        },
    ];


    return (
        <div>
            {/* <Space className="mb-2">
                <ButtonAdd onClick={handleAddRow} />
            </Space> */}
            <CustomAntdTable
                columns={columns}
                dataSource={taskList}
                rowKey="id"
                pagination={false}
            />

        </div>
    );
}
